class Event {
  queue: {
    [key: string]: any
  };
  onceQueue: {
    [key: string]: any
  };
  constructor() {
    this.queue = {};
    this.onceQueue = {};
  }
  $on(name: string, callback: any) {
    this.queue[name] = this.queue[name] || [];
    this.queue[name].push(callback);
  }
  $once(name: string, callback: any) {
    this.onceQueue[name] = this.onceQueue[name] || [];
    this.onceQueue[name].push(callback);
  }
  $off(name: string, callback: any) {
    if (callback) {
      if (this.queue[name]) {
        for (let i = 0; i < this.queue[name].length; i++) {
          if (this.queue[name][i] === callback) {
            this.queue[name].splice(i, 1);
            break;
          }
        }
      }
    } else {
      delete this.queue[name];
    }
  }
  $emit(name: string, data: any) {
    if (this.queue[name]) {
      this.queue[name].forEach(function (callback: (arg0: any) => void) {
        callback(data);
      });
    }
    if (this.onceQueue[name]) {
      this.onceQueue[name].forEach(function (callback: (arg0: any) => void) {
        callback(data);
      });
      delete this.onceQueue[name];
    }
  }
}
export default new Event();
